import React, { memo, useCallback, useMemo } from 'react';

import { Button, DynamicIconWrapper, Icons, SpinnerOverlay } from '@components/common';
import FlatTree from '@components/common/FlatTree';

import { useMutateMavenirConfigExport } from '@hooks/dataSources/useMutateMavenirConfigExport';
import useQueryMavenirConfigView from '@hooks/dataSources/useQueryMavenirConfigView';

import { convertToFlatTreeData } from '@components/common/FlatTree/utils';

import styles from './MavenirConfigTree.module.scss';

interface IMavenirConfigTree {
	id: string;
	onClose: () => void;
}

const MavenirConfigTree = ({
	id,
	onClose,
}: IMavenirConfigTree) => {
	const { exportConfig, isLoadingExportConfig } = useMutateMavenirConfigExport();
	const { configTree, isLoadingMavenirConfigTree } = useQueryMavenirConfigView(id);

	const handleExportConfig = useCallback(() => {
		if (!id) return;

		exportConfig(id);
	}, [exportConfig, id]);

	const treeData = useMemo(() => {
		return configTree
			? convertToFlatTreeData(JSON.parse(configTree))
			: [];
	}, [configTree]);

	return (
		<div className={styles.wrapper}>
			{(isLoadingMavenirConfigTree || isLoadingExportConfig) && <SpinnerOverlay />}
			<FlatTree
				isReadOnly
				treeData={treeData}
				wrapperClassName={styles.flatTreeWrapper}
			/>
			<div className={styles.buttonWrapper}>
				<DynamicIconWrapper
					icon={Icons.export}
					isDisabled={!configTree}
					onClick={handleExportConfig}
					tooltipLabel='Export'
				/>
				<Button
					onClick={onClose}
					text='Close'
				/>
			</div>
		</div>
	);
};

export default memo(MavenirConfigTree);
